import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  const isDragging = useRef(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setScrollPercent(percent);

      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToPercent = (clientX) => {
    const rect = containerRef.current.getBoundingClientRect();
    const percent = (clientX - rect.left) / rect.width;

    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    window.scrollTo({
      top: scrollHeight * Math.max(0, Math.min(1, percent)),
      behavior: "auto",
    });
  };

  const handleClick = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;

    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    window.scrollTo({
      top: scrollHeight * Math.max(0, Math.min(1, percent)),
      behavior: "smooth",
    });
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    scrollToPercent(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    scrollToPercent(e.clientX);
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <div
        ref={containerRef}
        className="scroll-progress-container"
        onMouseDown={handleMouseDown}
        onClick={handleClick}
      >
        <div
          className="scroll-progress-bar"
          style={{ width: `${scrollPercent}%` }}
        />
      </div>

      <nav className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="nav-container">
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            <span className="logo-text">Shim Seohoon</span>
            <span className="logo-subtitle">Cyber Security Portfolio</span>
          </Link>

          <div className={`nav-links ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <Link to="/" onClick={closeMobileMenu}>
              홈
            </Link>
            <Link to="/about" onClick={closeMobileMenu}>
              소개
            </Link>
            <Link to="/projects" onClick={closeMobileMenu}>
              프로젝트
            </Link>
            <Link to="/blog" onClick={closeMobileMenu}>
              블로그
            </Link> {/* -------------------------------------------------------------------------------------------------------- */}
            <Link to="/contact" onClick={closeMobileMenu}>
              연락처
            </Link>
          </div>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="메뉴 토글"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default Header;
